import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "A player submitted a new custom card-back request" — sent to managers
 * (arena.manageCards) when the forumaker-arena.notify_new_custom_card_back_requests
 * setting is on (see CustomCardBackRequestedBlueprint /
 * RequestCustomCardBackController). Subject is the requester, so this both
 * names them (via data.requesterName, baked in server-side) and links to
 * their profile — there's no forum-side route into the admin panel's Card
 * Backs tab to link to instead.
 */
export default class CustomCardBackRequestedNotification extends Notification {
  icon() {
    return 'fas fa-palette';
  }
  href() {
    const user = this.attrs.notification.subject();
    return user ? app.route('user', {
      username: user.username()
    }) : '#';
  }
  content() {
    var _content$requesterNam;
    const content = this.attrs.notification.content() || {};
    const name = (_content$requesterNam = content.requesterName) != null ? _content$requesterNam : '';
    return app.translator.trans('forumaker-arena.forum.notifications.custom_card_back_requested_text', {
      name
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/CustomCardBackRequestedNotification', CustomCardBackRequestedNotification);